<template>
  <div >
    <el-dialog
      :visible.sync="dialogVisible"
      :modal-append-to-body="false"
      style="margin-top:1vh;"
      width="800px"
      :close-on-click-modal="false"
    >
      <div slot="title" class="title">客户联系统计</div>
      <div class="table-container">
        <div class="btn-wrap">
          <el-tag class="select-stafft-wrap" title="选择员工"  :closable="searchMenNames.length===0?false:true" @close="searchCloseTag" type="medium" effect="plain" @click="clickAddMember()">
            <span v-if="searchMenNames.length===0">选择员工</span>
            <span class="staff-names" v-for="(item,index) in searchMenNames" :key="index">{{item.name}}<span v-show="searchMenNames.length>1&&index!=searchMenNames.length-1">,</span></span>
          </el-tag>
          <div class="btn-group">
            <div class="btn" :class="params.mark==-1?'btn-active':''" @click="dateChange(-1)">昨日</div>
            <div class="btn" :class="params.mark==7?'btn-active':''" @click="dateChange(7)">近7日</div>
            <div class="btn" :class="params.mark==30?'btn-active':''" @click="dateChange(30)">近30日</div>
          </div>
          <el-date-picker
            v-model="searchSelectTime"
            size="mini"
            :editable="false"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="-"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            :picker-options="pickerOptions"
            @change="selectTime"
            style="width: 240px;"
          >
          </el-date-picker>
        </div>
        <div class="table-data">
          <el-table 
            size="medium" 
            :header-cell-style="{background:'#eef1f6',color:'#606266'}" 
            ref="singleTable"
            v-loading="loading"
            :highlight-current-row="true" 
            :data="tableData" 
            @sort-change="customerSortChange"
            :default-sort = "{prop: 'chatCnt', order: 'descending'}"
            height="308px"
            style="width: 100%;height:100%;font-size: 13px">
              <el-table-column show-overflow-tooltip prop="userName" label="员工姓名" width="118" align="left"></el-table-column>
              <el-table-column prop="chatCnt" label="聊天总数" sortable="custom" min-width="102" align="center" ></el-table-column>
              <el-table-column prop="messageCnt" label="发送聊天数" sortable="custom" min-width="102" align="center" ></el-table-column>
              <el-table-column prop="avgReplyTime" label="平均首次回复时长" sortable="custom" min-width="144" align="center" ></el-table-column>
              <el-table-column prop="newApplyCnt" label="发起申请数" sortable="custom" min-width="102" align="center"></el-table-column>
              <el-table-column prop="newContactCnt" label="新增好友数" sortable="custom" min-width="102" align="center"></el-table-column>
          </el-table>
        </div>
        <el-pagination
          :background="true"
          @current-change="callBack"
          :current-page.sync="pageparm.currentPage"
          :page-size="pageparm.pageSize"
          layout="prev, pager, next, jumper"
          :total="pageparm.total">
        </el-pagination>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary"   @click="dialogVisible=false" >确定</el-button>
      </div>
    </el-dialog>
    <!-- 添加人员树 -->
    <!-- <AddMemberView title="选择成员" :dialogVisibleTree="dialogVisibleTree" :currentSelectMember='currentSelectMember' @closeTree='closeTree' @clickSubmitTree='clickSubmitTree'></AddMemberView> -->
    <StaffTree title="选择成员" :dialogVisibleTree="dialogVisibleTree" :currentSelectMember='currentSelectMember' @closeTree='closeTree' @clickSubmitTree='clickSubmitTree' ></StaffTree>
  </div>
</template>

<script>
import AddMemberView from "@/views/code/components/addMember.vue"
import StaffTree from '@/components/staffTree/staffTree.vue'
import {getCusChatDetail} from '@/api/dataStatistics/dataStatistics.js'
export default {
  name: 'customerContact',
  components: {
    // AddMemberView,
    StaffTree
  },
  data() {
    return {
      dialogVisibleTree: false,
      currentSelectMember: [],                                // 当前选中的成员树
      // btnActive: 7,
      searchSelectTime: '',  
      dialogVisible: false,
      searchMenNames: [],
      params: {
        mark: 7,    //标识 -1：昨日  7：近七日  30：近30日  【int，非必传,mark与统计时间范围要选择其中一个，如果两者都选按mark为准】
        userIdList: [],    //员工userId数组【非必传】
        startTime: "",    //开始时间【string，非必传，mark与统计时间要选择一个，如果两者都选按mark为准】
        endTime: "",    //结束时间【string，非必传，mark与统计时间要选择一个，如果两者都选按mark为准】
        chatCntSort: "chatCntSortDesc",    //聊天总数排序【非必传】
        avgReplyTimeSort: "",    //平均首次回复时长排序【非必传】
        messageCntSort: "",     //发送聊天数排序【非必传】
        newApplyCntSort: "",    //发送申请数排序【非必传】
        newContactCntSort: "",    //新增好友数排序【非必传】
        pageNum: 1,    //页码
        pageSize: 10    //页数
      },
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 13,
      },
      pageSizes: [20, 50, 100, 200,500], //分页条数
      tableData: [],
      loading: false,
      // 禁选时间
      pickerOptions: {
        disabledDate(time) {
          let curDate = new Date().getTime();
          const day = 180 * 24 * 3600 * 1000;
          return time.getTime() > new Date(new Date().setHours(23, 59, 59, 999)).getTime() - 8.64e7 || time.getTime() < (curDate - day);
        },
      },
    }
  },
  methods: {
    show() {
      this.dialogVisible = true;
      this.getTableData()
    },
    dateChange(val) {
      this.searchSelectTime = ''
      this.params.startTime = ''
      this.params.endTime = ''
      this.params.mark = val
      this.params.pageNum = 1
      this.pageparm.currentPage = 1
      this.getTableData()
    },
    customerSortChange(val) {
      this.params.chatCntSort = ''
      this.params.messageCntSort = ''
      this.params.newApplyCntSort = ''
      this.params.avgReplyTimeSort = ''
      this.params.newContactCntSort = ''
      this.pageparm.currentPage = 1
      this.params.pageNum = 1
      switch(val.prop) {
        case 'chatCnt':
          // 聊天总数
          this.params.chatCntSort = (val.order == 'descending'?'chatCntSortDesc':(val.order == 'ascending'?'chatCntSortAsc':''))
          break
        case 'messageCnt':
        // 发送聊天数
          this.params.messageCntSort = (val.order == 'descending'?'messageCntSortDesc':(val.order == 'ascending'?'messageCntSortAsc':''))
          break
        case 'avgReplyTime':
        // 平均首次回复时长数
          this.params.avgReplyTimeSort = (val.order == 'descending'?'avgReplyTimeSortDesc':(val.order == 'ascending'?'avgReplyTimeSortAsc':''))
          break
        case 'newApplyCnt': 
        // 发起申请数
          this.params.newApplyCntSort = (val.order == 'descending'?'newApplyCntSortDesc':(val.order == 'ascending'?'newApplyCntSortAsc':''))
          break
        case 'newContactCnt': 
          // 新增好友数
          this.params.newContactCntSort = (val.order == 'descending'?'newContactCntSortDesc':(val.order == 'ascending'?'newContactCntSortAsc':''))
          break
      }
      this.getTableData()
    },
    // 搜索-添加成员
    clickAddMember(){
      this.dialogVisibleTree = true;
    },
    // 成员树的事件
    clickSubmitTree(val){
      this.searchMenNames = [];
      this.currentSelectMember = val.currentMember;
      this.dialogVisibleTree = false;
      this.params.userIdList = [];
      val.sendArray.forEach(item => {
        let obj = {
          userId: item.userId,
          name: item.userName
        }
        this.searchMenNames.push(obj)
        this.params.userIdList.push(item.userId)
      })
      this.params.pageNum = 1
      this.pageparm.currentPage = 1
      // 发送请求
      this.getTableData()
    },
    // 树关闭
    closeTree(val){
      this.dialogVisibleTree = false;
    },
    searchCloseTag() {
      this.searchMenNames = [];
      this.currentSelectMember = []
      this.params.userIdList = []
      this.getTableData()
    },
    selectTime(dataTime) {
      if(dataTime != null) {
        this.params.startTime = dataTime[0]
        this.params.endTime = dataTime[1]
      }else {
        this.params.startTime = ''
        this.params.endTime = ''
      }
      this.pageparm.currentPage = 1
      this.params.pageNum = 1
      this.params.mark = ''
      this.getTableData()
    },
    callBack(parm) {
      this.params.pageNum = parm
      this.getTableData()
    },
     // 获取表格数据
    getTableData() {
      this.loading = true
      getCusChatDetail(this.params,localStorage.getItem("Authorization"),true).then(res => {
        if(res.error.code==200){
          this.tableData = res.data.cusChatDetail
          this.pageparm.total = res.data.total
          this.loading = false
        }else {
          this.$message.error('获取表格数据失败，请重试！')
          this.loading = false
        }
      }).catch((err)=>{
        this.$message.error('获取表格数据失败，请重试！')
        this.loading = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.btn-wrap {
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  /deep/.select-stafft-wrap {
    margin-right: 10px;
    width: 180px;
    position: relative;
    cursor: pointer;
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    .el-icon-close{
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 5px;
    }
    .staff-names {
      color: #606266;
    }
  }
  /deep/ .el-tag--plain{
    border-color: #DCDFE6;
    color: #C0C4CF;
  }
}
.table-data {
  margin-bottom: 16px;
}
.btn-group {
  margin-right: 12px;
  display: flex;
  align-items: center;
  background-color: white;
  cursor: pointer;
  font-size: 13px;
  .btn {
    padding: 5px 16px;
    border: 1px solid #E6E9EB;
    &:first-child {
      border-top-left-radius: 4px;
      border-bottom-left-radius: 4px;
      border-right: none;
    }
    &:not(:first-child):not(:last-child) {
      border-radius: 0;
      border-right: none;
    }
    &:last-child {
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
    }
    &:hover {
      color: #409EFF;
      border-color: #c6e2ff;
      background-color: #ecf5ff;
    }
  }
  .btn-active {
    color: white;
    border-color: #4080F9;
    background-color: #4080F9;
    &:hover {
      color: white;
      border-color: #4080F9;
      background-color: #4080F9;
    }
  }
}
// /deep/.el-pagination {
//   .btn-prev,.btn-next {
//     background-color: white;
//     border: 1px solid #E6E9EB;
//   }
//   .el-pager  {
//     li {
//       background-color: white;
//       // border: 1px solid #2684FF;
//       color: rgba(0, 0, 0, 0.6);
//       border: 1px solid #E6E9EB;
//       border-radius: 2px;
//     }
//     li:not(.disabled).active {
//       border: 1px solid #2684FF;
//       color: #2684FF;
//       background-color: white;
//     }
//   }
// }
/deep/ .el-dialog__header {
  padding: 28px 28px 10px 32px;
}
/deep/ .el-dialog__body {
  padding: 14px 32px 6px;
}
/deep/ .el-dialog__footer {
  padding: 4px 32px 32px;
  .el-button {
    width: 88px;
    height: 32px;
    padding: 0;
  }
}
</style>